import { createContext } from "react";
import { SOCKET_URL } from "../config/apiURL";
import { storage } from "../config/storage";
import { io } from "socket.io-client";

export const SocketContext = createContext({});

const SocketProvider = ({ children, namespace="" }) => {
    const _socket = io(`${SOCKET_URL}${namespace}`, {
        auth: {
          token: storage.fetchFromLocalStorage.token(),
          session: storage.fetchFromSessionStorage.sessionKey(),
        },
        autoConnect: false, //By default, the Socket.IO client opens a connection to the server right away. You can prevent this behavior with the autoConnect option:
        path: process.env.REACT_APP_IS_STAGING ? `/staging/socket.io` : `/socket.io`,
    });

    const values = {
        socket: _socket
    }

    console.log(_socket)

    return (
        <SocketContext.Provider value={values}>
            {children}
        </SocketContext.Provider>
    );
};

export default SocketProvider;
